import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { UserSession } from '@fleetops/types'

interface AuthState {
  session: UserSession | null
  isLoading: boolean
  isInitialized: boolean

  setSession: (session: UserSession | null) => void
  setLoading: (loading: boolean) => void
  setInitialized: () => void
  clearSession: () => void
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        session: null,
        isLoading: true,
        isInitialized: false,

        setSession: (session) => set({ session }),
        setLoading: (isLoading) => set({ isLoading }),
        setInitialized: () => set({ isInitialized: true, isLoading: false }),
        clearSession: () => set({ session: null }),
      }),
      {
        name: 'fleetops-auth',
        partialize: (state) => ({ session: state.session }),
      },
    ),
    { name: 'AuthStore' },
  ),
)

// Selector helpers — avoid re-renders by selecting only what's needed
export const useSession = () => useAuthStore((s) => s.session)
export const useIsAuthenticated = () => useAuthStore((s) => s.session !== null)
export const useTenantId = () => useAuthStore((s) => s.session?.tenantId)
export const useUserRole = () => useAuthStore((s) => s.session?.role)
